var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 1H11.5004C11.898 1 12.2793 1.158 12.5607 1.4395C12.8422 1.7205 13.0004 2.102 13.0004 2.5V12.5C13.0004 12.898 12.8422 13.2795 12.5607 13.5605C12.2793 13.842 11.898 14 11.5004 14H1.5C1.10236 14 0.721091 13.842 0.439637 13.5605C0.158182 13.2795 0 12.898 0 12.5V2.5C0 2.102 0.158182 1.7205 0.439637 1.4395C0.721091 1.158 1.10236 1 1.5 1H2.50036V0.5C2.50036 0.224 2.724 0 3 0C3.276 0 3.50018 0.224 3.50018 0.5V1H6.00001V0.5C6.00001 0.224 6.22418 0 6.50018 0C6.77618 0 7.00036 0.224 7.00036 0.5V1H9.50019V0.5C9.50019 0.224 9.72436 0 10.0004 0C10.2764 0 10.5 0.224 10.5 0.5V1ZM2.50036 2H1.5C1.36746 2 1.24036 2.0525 1.14654 2.1465C1.05272 2.24 1.00036 2.3675 1.00036 2.5V4H12V2.5C12 2.3675 11.9476 2.24 11.8538 2.1465C11.76 2.0525 11.6329 2 11.5004 2H10.5V2.5C10.5 2.776 10.2764 3 10.0004 3C9.72436 3 9.50019 2.776 9.50019 2.5V2H7.00036V2.5C7.00036 2.776 6.77618 3 6.50018 3C6.22418 3 6.00001 2.776 6.00001 2.5V2H3.50018V2.5C3.50018 2.776 3.276 3 3 3C2.724 3 2.50036 2.776 2.50036 2.5V2ZM1.00036 5V12.5C1.00036 12.6325 1.05272 12.76 1.14654 12.8535C1.24036 12.9475 1.36746 13 1.5 13H11.5004C11.6329 13 11.76 12.9475 11.8538 12.8535C11.9476 12.76 12 12.6325 12 12.5V5H1.00036Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/date-icon.16f5fc787e2a8c301daef14acc666a0f.svg";
export { ForwardRef as ReactComponent };